import React from 'react';
import { ImageOverlay } from 'react-leaflet';
import Leaflet, { LatLngBoundsLiteral } from 'leaflet';

import MapContainer from '../common/MapContainer';
import { SubEventType } from 'types/App';
import { useController, useWatch } from 'react-hook-form';
import FilePicker from 'components/common/FilePicker';
import { toast } from 'react-toastify';
import { FormControl } from '@mui/material';
import ImageOverlayRotated from 'components/MyEvents/Track/ImageOverlayRotated';

const PolygonMap = ({ imageSrcData, subEvent }: { imageSrcData?: string; subEvent: SubEventType }) => {
  const height = useWatch({ name: 'height' });
  const width = useWatch({ name: 'width' });
  const event = subEvent.event;

  const {
    field: { value: topLeft, onChange: setTopLeft }
  } = useController({ name: 'topLeft' });

  const {
    field: { value: topRight, onChange: setTopRight }
  } = useController({ name: 'topRight' });

  const {
    field: { value: bottomLeft, onChange: setBottomLeft }
  } = useController({ name: 'bottomLeft' });

  const mapBounds: LatLngBoundsLiteral = React.useMemo(
    () => [
      [0, 0],
      [height, width]
    ],
    [height, width]
  );

  const [isSetJson, setIsSetJson] = React.useState<boolean>(false);

  const handleJsonFile: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.files && e.target.files[0]) {
      const reader = new window.FileReader();
      const file = e.target.files[0];
      const fileName = file.name || '';
      const extension = fileName.split('.').pop()?.toLowerCase() || ' ';
      if (extension !== 'json') {
        toast.error('Wrong file type');
      } else {
        reader.onload = (e) => {
          try {
            const data = JSON.parse(e.target?.result as string);
            const vertices = data?.polygon?.vertices;
            if (vertices) {
              const { latitude, longitude } = vertices[0];
              const { latitude: latitude3, longitude: longitude3 } = vertices[2];
              const { latitude: latitude4, longitude: longitude4 } = vertices[3];
              const topLeft = {
                lat: latitude4,
                lng: longitude4
              };
              const topRight = {
                lat: latitude3,
                lng: longitude3
              };
              const bottomLeft = {
                lat: latitude,
                lng: longitude
              };
              setTopLeft(topLeft);
              setTopRight(topRight);
              setBottomLeft(bottomLeft);
              setIsSetJson(true);
            }
          } catch (err) {
            console.log(err);
          }
        };
        reader.readAsText(file);
      }
    }
  };

  if (!imageSrcData) {
    return null;
  }

  return (
    <React.Fragment>
      {!isSetJson ? (
        <React.Fragment>
          <MapContainer
            className="leaflet-crosshair"
            bounds={mapBounds}
            style={{ width: '100%', height: '650px', position: 'relative' }}
            crs={Leaflet.CRS.Simple}
            minZoom={-3}
            noTileLayer
          >
            <ImageOverlay url={imageSrcData} bounds={mapBounds} />
          </MapContainer>
          <FormControl fullWidth margin="normal">
            <FilePicker label="Select json file" accept=".json" onFileChange={handleJsonFile} />
          </FormControl>
        </React.Fragment>
      ) : (
        <MapContainer
          center={event.location}
          zoom={event.zoom}
          className="leaflet-crosshair"
          style={{ width: '100%', height: '650px', position: 'relative' }}
        >
          <ImageOverlayRotated topLeft={topLeft} topRight={topRight} bottomLeft={bottomLeft} opacity={0.5} image={imageSrcData} />
        </MapContainer>
      )}
    </React.Fragment>
  );
};

export default PolygonMap;
